import { Button, Group, Loader, Modal, Text } from '@mantine/core';
import { useState } from 'react';
import { useIntl } from 'react-intl';
import { notifications } from '@mantine/notifications';
import { myFetch } from '@commons/fetch';

export const DeleteModal = ({
  model,
  onClose,
}: {
  model: any;
  onClose: () => void;
}) => {
  const intl = useIntl();
  const [isDeleting, setIsDeleting] = useState<boolean>(false);

  const handleDelete = async () => {
    try {
      setIsDeleting(true);

      await myFetch(`/${model.owner}/models/${model.id}`, {
        method: 'DELETE',
      });

      notifications.show({
        color: 'green',
        title: intl.formatMessage({ id: 'success' }),
        message: intl.formatMessage(
          { id: 'deletedModel' },
          { name: model.name }
        ),
      });

      onClose();
    } catch (err: any) {
      notifications.show({
        color: 'red',
        title: intl.formatMessage({ id: 'error' }),
        message: err?.message || intl.formatMessage({ id: 'error' }),
      });
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <Modal
      title={intl.formatMessage({ id: 'delete' })}
      size="lg"
      centered
      opened={model !== null}
      onClose={onClose}
      closeOnClickOutside={!isDeleting}
      closeOnEscape={!isDeleting}
      withCloseButton={!isDeleting}
    >
      <Text>
        {intl.formatMessage({ id: 'areYouSureYouWantToDelete' })} "
        <strong>{model?.name}</strong>"?
      </Text>

      <Group mt="lg" justify="flex-end">
        <Button disabled={isDeleting} onClick={onClose} variant="default">
          {intl.formatMessage({ id: 'cancel' })}
        </Button>
        <Button
          leftSection={isDeleting ? <Loader size="xs" /> : undefined}
          disabled={isDeleting}
          onClick={handleDelete}
          color="red"
        >
          {intl.formatMessage({ id: 'delete' })}
        </Button>
      </Group>
    </Modal>
  );
};
